const members = [
  {
    name: "Thomas Alexandro",
    position: "Director of AOT",
    imgUrl: "/img/speaker1.svg",
    desc: "",
  },
  {
    name: "Jenny Jenifer",
    position: "Assistant professor at AOT",
    imgUrl: "/img/speaker2.svg",
    desc: "",
  },
  {
    name: "Thomas Alexandro",
    position: "Professor at AOT",
    imgUrl: "/img/speaker1.svg",
    desc: "",
  },
  {
    name: "Jenny Jenifer",
    position: "Professor at AOT",
    imgUrl: "/img/speaker2.svg",
    desc: "",
  },
];
export default members;
